import { z } from "zod";

const GeometrySchema = z.object({
  type: z.literal("Polygon"),
  coordinates: z.array(z.array(z.array(z.number()))),
});

const FeatureSchema = z.object({
  type: z.literal("Feature"),
  id: z.number().optional(),
  geometry: GeometrySchema,
  properties: z.record(z.string(), z.any()),
});

const CRSSchema = z.object({
  type: z.literal("name"),
  properties: z.object({
    name: z.string(),
  }),
});

export const GeoJSONSchema = z.object({
  type: z.literal("FeatureCollection"),
  features: z.array(FeatureSchema),
  crs: z.optional(CRSSchema),
});

export type GeoJSONS = z.infer<typeof GeoJSONSchema>;
